export default __webpack_public_path__ + "static/media/x.6c73a00e.svg";